import React from "react";
import Avatar from "./Avatar";
import "./brandcard.css";

interface BrandCardProps {
  label: string; // Brand Name
  description: string; // "Last active..."
  toneOfVoice: string[]; // List of tones
  target_audience: string[]; // List of target audiences
  socialMedias: string[]; // List of social medias
  onEdit?: () => void;
  onDelete?: () => void;
  isDeleteVisible?: boolean;
  onViewDetails?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const BrandCard: React.FC<BrandCardProps> = ({
  label,
  description,
  toneOfVoice,
  target_audience,
  socialMedias,
  onEdit,
  onDelete,
  isDeleteVisible = true,
  onViewDetails,
  className = "",
  style = {},
}) => {
  // Helper to get color/initials for social media if icons are missing
  const getSocialIcon = (social: string) => {
    const s = social.toLowerCase();
    let initial = s.substring(0, 1).toUpperCase();
    let bgColor = "#E5E7EB"; // default grey
    let color = "#6B7280";

    if (s.includes("linkedIn")) {
      initial = "in";
      bgColor = "#0077b5";
      color = "#ffffff";
    } else if (s.includes("instagram")) {
      initial = "Ig";
      bgColor = "#e1306c";
      color = "#ffffff";
    } else if (s.includes("x") || s.includes("twitter")) {
      initial = "X";
      bgColor = "#000000";
      color = "#ffffff";
    } else if (s.includes("reddit")) {
      initial = "Rd";
      bgColor = "#ff4500";
      color = "#ffffff";
    } else if (s.includes("tiktok")) {
      initial = "Tt";
      bgColor = "#000000";
      color = "#ffffff";
    }

    return (
      <div
        className="social-icon"
        title={social}
        style={{ backgroundColor: bgColor, color: color }}
      >
        {initial}
      </div>
    );
  };

  const handleCardKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (!onViewDetails) {
      return;
    }

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onViewDetails();
    }
  };

  return (
    <div
      className={`brand-card ${onViewDetails ? "brand-card--clickable" : ""} ${className}`}
      style={style}
      role={onViewDetails ? "button" : undefined}
      tabIndex={onViewDetails ? 0 : undefined}
      aria-label={onViewDetails ? `Open ${label} workspace` : undefined}
      onClick={onViewDetails}
      onKeyDown={handleCardKeyDown}
    >
      {/* Header */}
      <div className="brand-card-header">
        <div className="brand-info">
          <Avatar
            name={label}
            size="medium"
            style={{
              backgroundColor: "#E0E7FF",
              color: "#4F46E5",
              fontSize: "18px",
            }}
          />
          <div className="brand-text">
            <h3>{label}</h3>
            <p>{description}</p>
          </div>
        </div>
        {/* <div className="brand-actions">
          {onEdit && (
            <span
              className="action-icon"
              role="button"
              aria-label="Edit"
              onClick={(e) => { e.stopPropagation(); onEdit(); }}
              style={{ color: '#94A3B8' }}
            >
              <Pencil size={18} />
            </span>
          )}
          {isDeleteVisible && onDelete && (
            <span
              className="action-icon"
              role="button"
              aria-label="Delete"
              onClick={(e) => { e.stopPropagation(); onDelete(); }}
              style={{ color: '#E17375' }}
            >
              <Trash2 size={18} />
            </span>
          )}
        </div> */}
      </div>

      {/* Tone of Voice */}
      <div className="brand-section">
        <div className="section-label">TONE OF VOICE</div>
        <div className="tone-chips">
          {toneOfVoice.map((tone, index) => (
            <div key={index} className="tone-chip">
              {tone}
            </div>
          ))}
        </div>
      </div>

      {/* Target Audience */}
      <div className="brand-section">
        <div className="section-label">TARGET AUDIENCE</div>
        <div className="audience-text">{target_audience.join(", ")}</div>
      </div>

      {/* Footer */}
      <div className="brand-footer">
        <div className="social-icons">
          {socialMedias.map((social, index) => (
            <React.Fragment key={index}>{getSocialIcon(social)}</React.Fragment>
          ))}
        </div>
        <span className="brand-card-open-label">Open workspace</span>
      </div>
    </div>
  );
};

export default BrandCard;
